import { createSelector } from '@ngrx/store';
import { selectApiMetadataState } from '../reducers';
import * as fromCxApiMetadata from '../reducers/cx-api-metadata.reducer';

export const selectCxApiMetadata = createSelector(selectApiMetadataState, fromCxApiMetadata.selectAll);
export const selectCxApiMetadataIds = createSelector(selectApiMetadataState, fromCxApiMetadata.selectIds);
export const selectCxApiMetadataEntities = createSelector(selectApiMetadataState, fromCxApiMetadata.selectEntities);
export const selectCxApiMetadataById = () =>
  createSelector(selectCxApiMetadataEntities, (cxApiMetadataEntities, { id }) => cxApiMetadataEntities[id]);
